module.exports = __webpack_public_path__ + "static/media/BMWK.52ca1b96.png";